import React, { useState } from 'react';
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
} from '@one-thd/sui-atomic-components';
import { useFitCompatibility } from '../FitCompatibilityProvider';
import {
  BuildDrawer
} from './drawerComponents';
import { REFRIGERATOR_MAPPING } from '../../applianceConstants/refrigerator';
import { LAUNDRY_DRAWER_MAPPING } from '../../applianceConstants/laundry';
import { RANGE_DRAWER_MAPPING } from '../../applianceConstants/range';
import { OTR_MICROWAVES_DRAWER_MAPPING } from '../../applianceConstants/otr-microwaves';
import { DISHWASHER_DRAWER_MAPPING } from '../../applianceConstants/dishwasher';
import { track } from '../../utils';

export const FitDrawer = () => {
  const {
    drawerPosition,
    hasInitialBackArrow,
    drawerOpen,
    setDrawerOpen,
    drawerIndex,
    setDrawerIndex,
    applianceType
  } = useFitCompatibility();

  const [selectedTab, setSelectedTab] = useState(0);

  const onDrawerClose = () => {
    setDrawerOpen(false);
    setDrawerIndex(0);
    setSelectedTab(0);
  };

  let mapping;
  switch (applianceType) {
  case 'REFRIGERATOR':
    mapping = REFRIGERATOR_MAPPING;
    break;
  case 'OTR_MICROWAVES':
    mapping = OTR_MICROWAVES_DRAWER_MAPPING;
    break;
  case 'RANGE':
    mapping = RANGE_DRAWER_MAPPING;
    break;
  case 'DISHWASHER':
    mapping = DISHWASHER_DRAWER_MAPPING;
    break;
  default:
    mapping = LAUNDRY_DRAWER_MAPPING;
    break;
  }

  const {
    header,
    sections,
    footer
  } = mapping[drawerIndex];

  const scrollToTop = () => {
    if (typeof document === 'undefined') return;

    const drawerElement = document.getElementById('fit-compatibility-drawer');
    if (drawerElement) {
      drawerElement.scrollTop = 0;
    }
  };

  if (drawerIndex === 4) {
    track('step4');
  }

  return (
    <Drawer
      DrawerRootProps={{
        id: 'fit-compatibility-drawer'
      }}
      position={drawerPosition}
      open={drawerOpen}
      onClose={onDrawerClose}
    >
      <DrawerHeader
        title={header}
        onClose={onDrawerClose}
        onBack={
          drawerIndex === 0 && !hasInitialBackArrow
            ? null
            : () => {
              if (drawerIndex === 0 && hasInitialBackArrow) {
                onDrawerClose();
              } else {
                setDrawerIndex(drawerIndex - 1);
              }
              scrollToTop();
            }
        }
      />
      <DrawerBody>
        <div className="sui-mt-2">
          {BuildDrawer(sections, 0, selectedTab, setSelectedTab)}
        </div>
      </DrawerBody>
      <DrawerFooter>
        <Button
          fullWidth
          onClick={() => {
            const indexBump = drawerIndex + 1;
            if (mapping[indexBump] === undefined) {
              onDrawerClose();
            } else {
              scrollToTop();
              setDrawerIndex(indexBump);
            }
          }}
        >
          {footer}
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};
